/** FHIR `Task` assignee: the practitioner's personalized Zoom Scheduler link. */
export type ConsultTaskAssignee = {
  firstName: string;
  scheduleUrl: string;
};

/**
 * Whether the assignee display name is the shared RD pool placeholder (FHIR human name "RD Pool"
 * maps to first name `RD`). Backend also omits assignee when Practitioner email is
 * `rdpool@wellbetty.com`; this is a client-side fallback.
 */
export function isRdPoolTaskAssigneePlaceholderFirstName(firstName: string): boolean {
  return firstName.trim().toLowerCase() === 'rd';
}
